export const ASAP = 'asap'
export const PREORDER = 'preorder'

export const COURIER_INITIALIZED = 'initialized'
export const COURIER_APPROVED = 'approved'
export const COURIER_QUEUED = 'queued'
export const COURIER_SEARCHING = 'searching'
export const COURIER_PICKING = 'picking'
export const COURIER_ALMOST_PICKING = 'almost_picking'
export const COURIER_WAITING_AT_PICKUP = 'waiting_at_pickup'
export const COURIER_DELIVERING = 'delivering'
export const COURIER_ALMOST_DELIVERING = 'almost_delivering'
export const COURIER_WAITING_AT_DROPOFF = 'waiting_at_dropoff'
export const COURIER_DELIVERED = 'delivered'
export const COURIER_FINISHED = 'finished'
export const COURIER_CANCELLED = 'cancelled'
export const COURIER_ERROR = 'error'

export const ORDER_NEW = 'new'
export const ORDER_APPROVED = 'approved'
export const ORDER_CANCELLED = 'cancelled'
export const ORDER_CANCELLED_AFTER_APPROVAL = 'cancelled-after-approval'
export const RESTAURANT_MANAGED = 'restaurant_managed'
// restaurant.third_party_type value that must NOT switch tracking into third-party mode
export const THIRD_PARTY_TYPE_NON_PARTNER = 'non_partner'
export const IN_PROGRESS_COURIER = [
    COURIER_INITIALIZED,
    COURIER_APPROVED,
    COURIER_QUEUED,
    COURIER_SEARCHING,
    COURIER_PICKING,
    COURIER_ALMOST_PICKING,
    COURIER_WAITING_AT_PICKUP,
    COURIER_DELIVERING,
    COURIER_ALMOST_DELIVERING,
    COURIER_WAITING_AT_DROPOFF,
]
export const SHOW_COURIER = [
    COURIER_DELIVERING,
    COURIER_ALMOST_DELIVERING,
    COURIER_WAITING_AT_DROPOFF,
]
export const SECTION_0 = [COURIER_INITIALIZED, COURIER_APPROVED]
export const SECTION_1 = [
    COURIER_QUEUED,
    COURIER_SEARCHING,
    COURIER_PICKING,
    COURIER_ALMOST_PICKING,
    COURIER_WAITING_AT_PICKUP,
]
export const SECTION_2 = [COURIER_DELIVERING, COURIER_ALMOST_DELIVERING, COURIER_WAITING_AT_DROPOFF]
export const SECTION_3 = [COURIER_DELIVERED]
